import React from 'react';
import { MapCanvas } from './MapCanvas';
export interface MapVisualAidProps {
  data: {
    mapId: string;
    highlightRegionIds?: string[];
    highlightStyle?: 'primary' | 'secondary' | 'subtle';
    label?: string;
  };
}
export function MapVisualAid({
  data
}: MapVisualAidProps) {
  return <div className="flex flex-col items-center gap-3 w-full" data-id="element-14136" data-mp="koogb61ckivl">
      <MapCanvas mapId={data.mapId} highlightRegionIds={data.highlightRegionIds} highlightStyle={data.highlightStyle} width={400} height={400} ariaLabel={data.label} data-id="element-14137" data-mp="km27z46mtzcb" />
      {data.label && <p className="text-sm font-medium text-stone-600 text-center" data-id="element-14138" data-mp="5q46d6dxw2sp">
          {data.label}
        </p>}
    </div>;
}